import { AxiosResponse } from 'axios';
import { ColumnDTO, exportFile } from 'medere-ui-framework';
import { axiosInstance } from '../App';
import {
    MailingReportDateRange,
    MailingReportDetailFilter,
    MailingReportDetailPageDTO,
    MailingReportMessageStateDTO,
    MailingReportNodeDTO,
} from '../dto/MailingReportDTO';

const BASE = '/api/secured/mailingreport';

export function getMailingReportSummary(range: MailingReportDateRange): Promise<MailingReportNodeDTO[]> {
    return axiosInstance.get(`${BASE}/getSummary`, { params: range }).then(r => r.data);
}

export function getMailingReportDetail(filter: MailingReportDetailFilter, offset: number, pageSize: number): Promise<MailingReportDetailPageDTO> {
    return axiosInstance.get(`${BASE}/getDetail`, { params: { ...filter, offset, pageSize } }).then(r => r.data);
}

/** Descarga el Excel con todas las filas del detalle que cumplen los filtros. */
export function exportMailingReportDetail(filter: MailingReportDetailFilter, columns: ColumnDTO[]): Promise<AxiosResponse> {
    return exportFile(`${BASE}/exportDetail`, { columns }, filter);
}

export function getMailingReportMessageStates(messageId: number): Promise<MailingReportMessageStateDTO[]> {
    return axiosInstance.get(`${BASE}/getMessageStates`, { params: { messageId } }).then(r => r.data);
}
